export class ValidationDto {
  id: string;
  msg: string;
}
